import { patientSortLabel } from '../../../../../../constants';
import { DropDownListMenu, DropDownMenuItem, DropDownMobileMenu } from 'components';
import { useDevice } from 'hooks';
import { patientsActions } from 'store/patients/slice';
import { useDispatch } from 'store/utils';
import { GetPatientCasesParams, PatientSort } from 'types';

type Props = {
  setShowSort: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  requestParams: GetPatientCasesParams;
  refElement: React.MutableRefObject<HTMLDivElement>;
};

export const SortOptions = ({ setShowSort, open, requestParams, refElement }: Props) => {
  const dispatch = useDispatch();
  const onOptionClickHandler = (callback: () => void) => () => {
    dispatch(patientsActions.resetPatientCasesBeforeUpdate());
    callback();
    setShowSort(false);
  };

  const { isTablet } = useDevice();

  const onDesktopClose = (event: MouseEvent | undefined) => {
    !refElement?.current?.contains(event?.target as HTMLElement) && setShowSort(false);
  };

  const requestParamsWithoutPage = { ...requestParams };
  delete requestParamsWithoutPage.page;
  const { sort } = requestParamsWithoutPage;

  const options = (
    <>
      <DropDownMenuItem
        name={patientSortLabel.mostRecent}
        isTouchDevice={isTablet}
        radio={true}
        checked={!sort}
        onClick={onOptionClickHandler(() => {
          const newParams = { ...requestParamsWithoutPage };
          delete newParams.sort;
          dispatch(patientsActions.setPatientPageFilters({ ...newParams }));
        })}
      />
      <DropDownMenuItem
        name={patientSortLabel[PatientSort.lastName]}
        isTouchDevice={isTablet}
        radio={true}
        checked={sort === PatientSort.lastName}
        onClick={onOptionClickHandler(() => {
          dispatch(patientsActions.setPatientPageFilters({ ...requestParamsWithoutPage, sort: PatientSort.lastName }));
        })}
      />
      <DropDownMenuItem
        name={patientSortLabel[PatientSort.idAsc]}
        isTouchDevice={isTablet}
        radio={true}
        checked={sort === PatientSort.idAsc}
        onClick={onOptionClickHandler(() => {
          dispatch(patientsActions.setPatientPageFilters({ ...requestParamsWithoutPage, sort: PatientSort.idAsc }));
        })}
      />
      <DropDownMenuItem
        name={patientSortLabel[PatientSort.idDesc]}
        isTouchDevice={isTablet}
        radio={true}
        checked={sort === PatientSort.idDesc}
        onClick={onOptionClickHandler(() => {
          dispatch(patientsActions.setPatientPageFilters({ ...requestParamsWithoutPage, sort: PatientSort.idDesc }));
        })}
      />
    </>
  );
  return (
    <>
      {isTablet ? (
        <>{open && <DropDownMobileMenu onClose={() => setShowSort(false)}>{options}</DropDownMobileMenu>}</>
      ) : (
        <DropDownListMenu isOpen={open} onClose={onDesktopClose} position="rightBottom">
          {options}
        </DropDownListMenu>
      )}
    </>
  );
};
